
export const DEALERDASHBOARD_DATA_GET="DEALERDASHBOARD_DATA_GET"
export const DEALERDASHBOARD_DATA_SUCCESS="DEALERDASHBOARD_DATA_SUCCESS"